/* eslint-disable no-bitwise */
/* eslint-disable @typescript-eslint/no-magic-numbers */
export const VALUES_FIELD_NAME = [
    'All',
    'Landscape',
    'Landscape (left)',
    'Landscape (right)',
    'Portrait',
    'Portrait (up)',
] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];

/* Can be any value between 0<->(2^4)-1 */
export type TYPES_FIELD_BYTEVALUE =
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15;

/* Various BitMask combinations needed for #VALUES_FIELD_BYTEVALUE */
const BYTEVALUE_LANDSCAPE_LEFT = (1 << 0) as TYPES_FIELD_BYTEVALUE; /* 1 */
const BYTEVALUE_LANDSCAPE_RIGHT = (1 << 1) as TYPES_FIELD_BYTEVALUE; /* 2 */
const BYTEVALUE_LANDSCAPE_PORTRAIT = (1 << 2) as TYPES_FIELD_BYTEVALUE; /* 4 */
const BYTEVALUE_LANDSCAPE_PORTRAIT_UPSIDE_DOWN = (1 << 3) as TYPES_FIELD_BYTEVALUE; /* 8 */

const BYTEVALUE_LANDSCAPE_ALL = (BYTEVALUE_LANDSCAPE_LEFT |
    BYTEVALUE_LANDSCAPE_RIGHT) as TYPES_FIELD_BYTEVALUE;
const BYTEVALUE_PORTRAIT_ALL = (BYTEVALUE_LANDSCAPE_PORTRAIT |
    BYTEVALUE_LANDSCAPE_PORTRAIT_UPSIDE_DOWN) as TYPES_FIELD_BYTEVALUE;
const BYTEVALUE_ALL = (BYTEVALUE_LANDSCAPE_ALL | BYTEVALUE_PORTRAIT_ALL) as TYPES_FIELD_BYTEVALUE;

export const VALUES_FIELD_BYTEVALUE: Record<TYPES_FIELD_NAME, TYPES_FIELD_BYTEVALUE> = {
    All: BYTEVALUE_ALL,
    Landscape: BYTEVALUE_LANDSCAPE_ALL,
    'Landscape (left)': BYTEVALUE_LANDSCAPE_LEFT,
    'Landscape (right)': BYTEVALUE_LANDSCAPE_RIGHT,
    Portrait: BYTEVALUE_LANDSCAPE_PORTRAIT,
    'Portrait (up)': BYTEVALUE_LANDSCAPE_PORTRAIT_UPSIDE_DOWN,
} as const;
